module.exports = __webpack_public_path__ + "ede0ecbd098f487a4aa7586323c049e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/b.png
// module id = 205
// module chunks = 0